import { Routes } from "@angular/router";

export const CommonLayout_ROUTES: Routes = [
  // Dashboard
  {
    path: "dashboard",
    loadChildren: () =>
      import("../../modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "accounts",
    loadChildren: () =>
      import("../../modules/account/account.module").then(
        (m) => m.AccountModule
      ),
  },
  {
    path: "users",
    loadChildren: () =>
      import("../../modules/users/users.module").then((m) => m.UsersModule),
  },
  {
    path: "mail",
    loadChildren: () =>
      import("../../modules/mail/mail.module").then((m) => m.MailModule),
  },
  {
    path: "article",
    loadChildren: () =>
      import("../../modules/article/article.module").then(
        (m) => m.ArticleModule
      ),
  },
  {
    path: "product",
    loadChildren: () =>
      import("../../modules/product/product.module").then(
        (m) => m.ProductModule
      ),
  },
  {
    path: "blog",
    loadChildren: () =>
      import("../../modules/blog/blog.module").then((m) => m.BlogModule),
  },
  {
    path: "qa",
    loadChildren: () =>
      import("./../../modules/QA/qa.module").then((m) => m.QaModule),
  },
  {
    path: "homepage",
    loadChildren: () =>
      import("../../modules/homepage/homepage.module").then(
        (m) => m.HomepageModule
      ),
  },
  {
    path: "tool",
    loadChildren: () =>
      import("../../modules/custom-tool/tool.module").then((m) => m.ToolModule),
  },
  {
    path: "tracking",
    loadChildren: () =>
      import("./../../modules/tracking/tracking.module").then(
        (m) => m.TrackingModule
      ),  
  },
  {
    path: "fcara",
    loadChildren: () =>
      import("./../../modules/fcara/fcara.module").then(
        (m) => m.FcaraModule
      ),
  },
  {
    path: "customer",
    loadChildren: () =>
      import("./../../modules/customer/customer.module").then(
        (m) => m.CustomerModule
      ),
  },
  // Pages
  {
    path: "pages",
    data: {
      title: "Pages ",
    },
    children: [
      {
        path: "",
        redirectTo: "/transaction",
        pathMatch: "full",
      },
      {
        path: "",
        loadChildren: () =>
          import("../../pages/pages.module").then((m) => m.PagesModule),
      },
    ],
  },
];
